import Storefront from 'utils/storefront';
import { edgesToNodes } from 'utils/storefront/format-resource';
import * as queries from 'utils/storefront/queries';

const fetchProduct = async (productHandle) => {
  const storefront = Storefront.getInstance();
  const response = await storefront.request({
    query: queries.productByHandle(),
    variables: {
      handle: productHandle,
    },
  });

  const product = response.data?.productByHandle ?? null;

  if (!product) {
    console.error(`Product with handle "${productHandle}" not found`);
    return { product: null };
  }
  return {
    product: {
      ...product,
      hideAddToCart: product.hideAddToCart?.value === 'true',
      images: edgesToNodes(product.images, 'image'),
      variants: edgesToNodes(product.variants, 'variant'),
    },
  };
};

export default fetchProduct;
